import { Box, Typography } from "@material-ui/core";
import { FC } from "react";

import { qar } from "../../../utils/generic";

const ListPrice: FC<any> = ({ record }) => {
  return (
    <Box display="flex" alignItems="center" mx={-0.5}>
      {record.discountPercentage > 0 && (
        <Box mx={0.5}>
          <Typography variant="body2">{qar(record.priceAfterDiscount)}</Typography>
        </Box>
      )}
      <Box mx={0.5}>
        <Typography
          color={record.discountPercentage > 0 ? "textSecondary" : "textPrimary"}
          variant="body2"
          style={{ textDecoration: record.discountPercentage > 0 ? "line-through" : "auto" }}
        >
          {qar(record.price)}
        </Typography>
      </Box>
    </Box>
  );
};

export default ListPrice;
